import { HashIcon, TableIcon, FileTextIcon } from "lucide-react";
import { AttributeKindEnum } from "@brewbase/db/types";

interface InsertButtonProps {
  position: number;
  onInsert: (position: number, kind: AttributeKindEnum) => void;
  isLocked: boolean;
  /** Restrict to a single scalar insert (operation Parameters section). */
  scalarOnly?: boolean;
  /** Override the scalar insert label; defaults to Parameter/Attribute. */
  scalarLabel?: string;
  /** Always show the insert options instead of revealing them on hover. */
  alwaysVisible?: boolean;
}

const btnClass =
  "flex items-center gap-1 px-2 py-0.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted bg-background border border-border transition-colors pointer-events-auto";

export function InsertButton({
  position,
  onInsert,
  isLocked,
  scalarOnly,
  scalarLabel,
  alwaysVisible,
}: InsertButtonProps) {
  if (isLocked) return null;

  return (
    <div className="group relative h-0 z-20">
      <div
        className={
          "absolute inset-x-0 top-0 -translate-y-1/2 flex items-center justify-center transition-opacity pointer-events-none " +
          (alwaysVisible ? "opacity-100" : "opacity-0 group-hover:opacity-100")
        }
      >
        <div className="absolute inset-x-0 top-1/2 border-t border-dashed border-border" />
        <div className="relative flex items-center gap-1">
          <button
            className={btnClass}
            onClick={() => onInsert(position, AttributeKindEnum.SINGLE_NUMBER)}
          >
            <HashIcon className="h-4 w-4" />
            {scalarLabel ?? (scalarOnly ? "Parameter" : "Attribute")}
          </button>
          {!scalarOnly && (
            <>
              <button
                className={btnClass}
                onClick={() =>
                  onInsert(position, AttributeKindEnum.TABULAR_DATA)
                }
              >
                <TableIcon className="h-4 w-4" />
                Table
              </button>
              <button
                className={btnClass}
                onClick={() => onInsert(position, AttributeKindEnum.INSTRUCTION)}
              >
                <FileTextIcon className="h-4 w-4" />
                Text
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
